/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Upsell_DescriptionInputs */

const fr_plan_upsell_description = /** @type {(inputs: Plan_Upsell_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les formules en ligne arrivent à la salle : choisissez la vôtre en quelques clics, puis gérez votre abonnement directement depuis l'application.`)
};

/**

* @param {Plan_Upsell_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_upsell_description = /** @type {((inputs?: Plan_Upsell_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Upsell_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_upsell_description(inputs)
});